module.exports = __webpack_public_path__ + "img/xmas_ico02.772f63a6.png";